export default "<div [innerHtml]=\"html\"></div>"